<template>
  <div class="divEditMain">
    <div class="c2_2_1_1">
      <!--按钮-->
      <div ref="divTest" class="divAction">
        <p class="pTopBarL">
          <b>{{ editRow.fnamestat }}</b>
        </p>
        <p class="pTopBarR">
          <button v-for="btn in p_btns" :key="btn.vkey" @click="toAct(btn.vkey)">
            {{ btn.vlabel }}
          </button>
          <button @click="toDo(31)">关闭</button>
        </p>
      </div>
      <!--编辑区-->
      <div class="divEdit">
        <!--头-->
        <div class="divEditHead">
          <div
            v-for="(mm,idx) in p_colm_top"
            :key="idx"
            :class="mm.vvtype===10?'editTdDiv2':'editTdDiv'">
            <!--label-->
            <p class="editTdDivL">
              <b v-if="mm.vmust">*</b>
              {{ mm.vlabel }}：
            </p>
            <!--input-->
            <p v-if="mm.vread" class="editTdDivR1">
              <input :value="editRow[mm.vkey]" readonly>
            </p>
            <p v-if="!mm.vread" :class="mm.vvtype===10?'editTdDivR2':'editTdDivR'">
              <input v-if="!mm.vvtype || mm.vvtype===6" v-model="editRow[mm.vkey]">
              <input v-if="comm.numIn(mm.vvtype,[1,9])" v-model="editRow[mm.vkey]" :placeholder="mm.vhint" type="number">
              <el-date-picker
                v-if="comm.numIn(mm.vvtype,[3,11])"
                v-model="editRow[mm.vkey]"
                :clearable="false"
                size="mini"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              /><!--short date-->
              <el-date-picker
                v-if="mm.vvtype===4"
                v-model="editRow[mm.vkey]"
                :clearable="false"
                size="mini"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              /><!--class="iptElDt"  long date  yyyy-MM-dd HH:mm:ss-->
              <input v-if="mm.vvtype===5" v-model="editRow[mm.vpkey]" type="hidden">
              <input
                v-if="mm.vvtype===5"
                v-model="editRow[mm.vkey]"
                type="text"
                @click="p17_toPicker(mm,-1)">
              <textarea
                v-if="mm.vvtype===10"
                v-model="editRow[mm.vkey]"/><!--备注，多行-->
            </p>
          </div><!--单个单行-->
        </div>
        <br>
        <!--体-->
        <div v-if="p_colm_ey.length>0" class="divEditEntry">
          <table style="width:98%;" class="editTb">
            <thead>
              <tr class="editTbHead">
                <th style="width:1%;max-width: 30px;min-width: 25px;"/>
                <th v-for="(row,idx) in p_colm_ey" :key="idx">{{ row.vlabel }}</th>
                <th style="width:4%;max-width: 60px;min-width: 40px;">
                  <b @click="addRow(idx,true)">+</b>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row,idx) in editEntrys" :key="idx">
                <td>{{ idx+1 }}</td>
                <td
                  v-for="(mm,eidx) in p_colm_ey"
                  :key="eidx"
                  :class="mm.vread?'tdRead':'tdEdit'"
                  :style="[{'width':mm.vwidth+'%'}]"
                  @mouseover="p27_eHover(row)"><!---->
                  <!---{{ mm.vvtype }} {{ mm.vkey }}--->
                  <p v-if="mm.vread" style="background-color:transparent;">{{ row[mm.vkey] }}</p>
                  <div v-if="!mm.vread">
                    <div v-if="mm.vchg">
                      <input v-if="!mm.vvtype||mm.vvtype===6" v-model="row[mm.vkey]" @change="eChg(mm.vchg,row)">
                      <input v-if="comm.numIn(mm.vvtype,[1,9])" v-model="row[mm.vkey]" type="number" @change="eChg(mm.vchg,row)">
                    </div>
                    <div v-if="!mm.vchg">
                      <input v-if="!mm.vvtype||mm.vvtype===6" v-model="row[mm.vkey]">
                      <input v-if="comm.numIn(mm.vvtype,[1,9]) && !mm.vchg" v-model="row[mm.vkey]" type="number">
                    </div>
                    <el-date-picker
                      v-if="mm.vvtype===3"
                      v-model="row[mm.vkey]"
                      :clearable="false"
                      size="mini"
                      type="date"
                      value-format="yyyy-MM-dd"
                    />
                    <input v-if="mm.vvtype===5" v-model="row[mm.vpkey]" type="hidden">
                    <input
                      v-if="mm.vvtype===5"
                      v-model="row[mm.vkey]"
                      type="text"
                      @click="p17_toPicker(mm,idx)">

                    <input v-if="mm.vvtype===8" v-model="row[mm.vkey]" type="checkbox">
                  </div>
                </td>
                <td class="tdAct">
                  <b @click="addRow(idx)">─</b><!---↔✖✖✚━ ╋┼─--->
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="editTbFoot">
                <th/>
                <th v-for="(row,idx) in p_colm_ey" :key="idx">{{ rowSum[row.vkey] }}</th>
                <th>.</th>
              </tr>
            </tfoot>
          </table>
        </div>
        <!--附件区-->
        <div v-if="editRow.fid>0" class="divUpload">
          <input
            ref="iptFile"
            type="file"
            hidden
            capture="camera"
            @change="getFile($event)"><!--    accept="image/jpeg,image/png,image/gif"-->
          <p class="pUpload" @click="toFile()">+<br>添加附件</p>
          <div v-for="(mm,idx) in upFiles" :key="idx" class="divUploadShow">
            <p class="pUpload">
              <a :href="$keys().mainUrl+mm.fpath" download="文件.xlsx" target="blank">{{ mm.fid?mm.filenmorg:mm.name }}</a>
              <i class="el-icon-error" @click="rmFile(mm)"/>
            </p>
          </div>
        </div>
        <!--打印-->
        <!--制单与审核-->
        <div class="divEdit3">
          <div
            v-for="(mm,idx) in p_colm_btm"
            :key="idx"
            class="divRead">
            <b>{{ mm.vlabel }}：</b>{{ editRow[mm.vkey] }}
          </div>
        </div>
      </div>
    </div>
    <CPicker
      v-if="bbPick"
      :p_ipt="iptObj"
      :a_pickup="p21_picked"
      :a_close="p22_clsPicker"/>
    <COption
      :p_css-top="iPageY"
      :p_css-left="iPageX"
      :p_options="oOptions"
      :p_idx="iOptPk"
      :a_pickup="p21_picked"/>
    <br><br><br><br><br><br><br><br><br><br>
  </div>
</template>
<script type="text/javascript">
import CPicker from '../c3_tools/03_picker.vue'
import COption from '../c3_tools/01_picker.vue'
import comm from '../../utils/comm'
import Editor from '../c3_tools/05_editor.vue'
import './../../../static/c_editb.css'
export default{
  name: 'CEdit',
  components: {
    CPicker,
    COption,
    Editor
  },
  props: {
    p_colm_top: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_colm_btm: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_colm_ey: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_btns: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_row: {
      type: Object,
      default: () => {
        return {}
      }
    },
    p_entry: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_idmenu: {
      type: Number,
      default: 0
    },
    toDo: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
      iOptPk: 0,
      iAct: 0,
      bbPick: false,
      bbPicking: false,
      bbUpdate: false,
      bbUpgrade: false,
      bbErr: false,
      sLike: '',
      iptObj: {},
      // pickParam: {},
      editRow: {}, // 整个，不包含editEntrys
      upFiles: [],
      idx: 0,
      iPageY: 0,
      iPageX: 0,
      rowCnt: [],
      oOptions: [],
      errMsg: '',
      editEntrys: [],
      rowSum: {}
    }
  },
  watch: {
    p_row: {
      handler: function(newV, oldV) {
        this.prt('watch.newV.要编辑的对象', newV)/*
        if (newV.fid === this.editRow.fid && newV.iChange === this.editRow.iChange) {
          return
        }*/
        this.editRow = newV
        this.mkEditor()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    prt(a, b) {
      console.log(`c02_edit.${a}`, b)
    },
    // 1保存 2新增 3复制 4审 5冲红 6 7 8 9删除 10 11分配1 12分配确认 13取消分配
    //  14 15 16 17 19出库(包含18)2 20取消出库 31关闭编辑 32导出
    // 40备货打印 41销售打印 42 43 44样品打印 45其他出库
    toAct(iAct) {
      this.iAct = iAct
      if (this.comm.numIn(iAct, [1, 3])) this.p01_toSave()
      else if (iAct === 62) this.p62_update()
      else if (iAct === 63) this.p63_upgrade()
      else this.toDo(iAct, this.editRow)
    },

    toFile() {
      this.$refs.iptFile.click()
    },
    getFile(event) {
      const iFile = event.target.files[0]
      this.$refs.iptFile.value = null
      this.prt('getFile.1', iFile)
      this.upFiles.push(iFile)
      this.prt('getFile.2', this.upFiles)
      /*
      const my = this
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        my.upFiles.push(fileReader.result)
      })
      fileReader.readAsDataURL(event.target.files[0])
      */ // 压缩
    },
    upFile() {
      this.prt('upFile', this.upFiles)
      this.bbLoading = true
      const frmData = new window.FormData()
      this.upFiles.forEach(row => {
        frmData.append('upFiles', row)
      })
      frmData.append('fidmenu', this.p_idmenu)
      frmData.append('fidparent', 0)
      return this.$upFile(this.$keys().urlUpFile, frmData)
    },
    pkFile(row) {
      this.$jGet('pkFile/' + row.fidmenu + '/' + row.fid, rs => {
        this.prt('pkFile', rs)
        if (rs.data.stat) this.upFiles = rs.data.data
      })
    },
    rmFile(iAct, fileId) {
      if (iAct === 1) {
        this.editId = fileId
        this.iAct = 16
      } else if (iAct === 2) {
        this.$jGet('rmFile/' + this.editId, rs => {
          this.prt('rmFile', rs)
          this.upFiles = this.upFiles.filter((row) => {
            return row.fid !== this.editId
          })
        })
      }
    },
    p16_rmFile(idx) {
      const list = this.upFiles.filter((row, e) => {
        return e !== idx
      })
      this.upFiles = list
    },
    toCopy(bbRed) {
      const eys = []
      const row = JSON.parse(JSON.stringify(this.editRow))
      if (bbRed) {
        row.fidsource = this.editRow.fid
        row.fcodesource = this.editRow.fcode
        row.fidtypesource = this.editRow.fidmenu
      }
      row.iAct = 1
      row.fred = 1
      row.fcode = null
      row.fid = null
      row.fstat = null
      row.fnamestat = null
      this.editEntry.forEach(row2 => {
        if (bbRed)row2.fidsource = row2.fidentry
        eys.push(row2)
      })
      row['entrys'] = eys
      this.prt('toRed.1', row)
      this.toDo(1, row)
    },
    mkValues(vLike, cbAct, pType) {
      if (vLike && vLike !== '') { // && !this.bbPick
        this.values = this.p_values.filter(row => this.itemFinder(row, vLike))
      } else {
        this.values = this.p_values
      }
      // console.log('c3_1_picker.mkValues.2', this.p_values)
      // cbAct(this.values)
    },
    mkEditor() {
      // this.prt('mkEditor.1.colm', this.p_colm_top)
      // ************以下是处理entry********** //
      if (!this.p_colm_ey || this.p_colm_ey.length === 0) return
      // 格式化数据
      this.editEntrys = this.p_entry
      if (this.editEntrys === undefined) this.editEntrys = []
      this.mk10Row()
    },
    mk10Row() {
      const rowCnt = this.editEntrys.length
      if (rowCnt > 10) return
      for (var j = 0; j < 10 - rowCnt; j++) {
        this.editEntrys.push({})
      }
    },
    p01_toSave() {
      this.prt('p01_toSave.1.editRow', this.editRow)
      this.errMsg = comm.ckMust(this.p_colm_top, this.editRow)
      if (this.errMsg !== '') {
        this.toDo(33, this.errMsg)// 提示
        return
      }
      const entrys = []
      this.editEntrys.forEach((row, e) => {
        if (row.fiditem) {
          const msg = comm.ckMustEy(this.p_colm_ey, row, e)
          if (msg === '') {
            entrys.push(row)
          } else {
            this.errMsg += msg
          }
        }
      })// entrys
      if (this.errMsg !== '') {
        this.toDo(33, this.errMsg)// 提示
        return
      }
      this.editRow['iAct'] = this.iAct
      this.editRow.entrys = entrys
      const files = this.upFiles.filter(row => { return !row.fid })
      this.editRow.upFiles = files
      this.toDo(this.iAct, this.editRow)
    },
    addRow(idx, bbAdd) {
      if (bbAdd) {
        this.editEntrys.push({})
      } else {
        this.editEntrys.splice(idx, 1)
      }
    },
    vChg(colm, val) {
      this.editRow[colm] = val
    },
    eChg(eAct, row) {
      this.prt('eChg.1，eAct：', eAct)
      if (!eAct) return
      if (this.comm.numIn(eAct, [1, 2, 3, 4])) { // 单价与数量 处理
        const fqty = this.comm.toNum(row.fqty)// mkNum
        const fprice = this.comm.toNum(row.fprice)// mkNum
        row.famount = (fqty * fprice).toFixed(2)
        if (eAct === '4' && row.fpqbox) {
          row = this.comm.mkBoxQty(row, row.fqty)
        }
      }
    },
    p09_toDelt() {
      const param = {
        iAct: 9,
        fidmenu: 0,
        fid: this.editRow.fid
      }
      this.toDo(9, param)
    },

    p22_clsPicker() {
      this.bbPick = false
    },
    p21_picked(pkRs) {
      this.prt('p21_picked.1.input Object', this.iptObj)
      this.prt('p21_picked.2.result', pkRs)
      this.prt('p21_picked.3.tr index', this.idx)/**/
      const my = this
      var vv = ''
      if (this.comm.numIn(my.iptObj.vbox, [1, 5])) { // 表体
        for (vv in pkRs) {
          if (!my.editEntrys[my.idx])my.editEntrys.push({})
          if (!my.editEntrys[my.idx][vv])my.editEntrys[my.idx][vv] = pkRs[vv]
          my.editEntrys[my.idx][vv + my.iptObj.vpkey] = pkRs[vv]
        }
        my.prt('p21_picked.5.editRow', my.editEntrys[my.idx])
        my.idx++
      } else { // 表头
        for (vv in pkRs) {
          my.editRow[vv + my.iptObj.vpkey] = pkRs[vv]
          if (!my.comm.ssIn(vv, ['fid', 'fcode', 'fname']))my.editRow[vv] = pkRs[vv]
        }
      }
      if (!this.iptObj.bbMutip) { // 非多选
        this.bbPick = false
        this.oOptions = []
      }
    },

    p17_toPicker(iptParam, idx) {
      this.prt('p17_toPicker.dblclick.iptParam', iptParam)
      this.iptObj = iptParam
      this.bbPick = true

      if (iptParam.relate) {
        iptParam[iptParam.relate] = this.editRow[iptParam.relate]
      }
      this.idx = idx
    },
    p17_toOption(e, idRow) {
      this.iPageY = (idRow || idRow === 0 ? e.clientY - 65 : e.layerY) // e.clientY// e.pageY - e.offsetY - e.layerY
      this.iPageX = (e.layerX > 120 ? e.layerX : 120)// e.clientX// e.pageX - e.offsetX - e.layerX
    }, // 仅能定位

    p27_eHover(row) {
      if (row && row.fiditem) { // && row.fqtyinvt
        this.rowSum.fcodeitem = row.fcodeitem
        // this.rowSum.fnameitem = ' 库存:' + this.comm.toNum(row.fqtyinvt)
      } else {
        this.rowSum.fcodeitem = ''
        this.rowSum.fnameitem = ''
      }
    },
    p62_update(bbOk) {
      if (bbOk) {
        this.bbUpdate = false
        this.editRow.equipCmd = 'update'
        this.toDo(1, this.editRow)
      } else {
        this.bbUpdate = true
      }
    },
    p63_upgrade(bbOk) {
      if (bbOk) {
        this.upFile().then(rs => {
          this.prt('p63_upgrade', rs)
          this.bbUpgrade = false
          this.editRow.equipCmd = 'upgrade'
          this.editRow.fileName = this.p_idmenu + '/0/' + this.upFiles[0].name
          this.toDo(1, this.editRow)
        })
      } else {
        this.bbUpgrade = true
        setTimeout(() => {
          this.$refs.iptFile.click()
        }, 500)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comps/c2_info/02_edit.vue